import { ITeam } from '../models/team';

function filterTeams(teams: ITeam[]): ITeam[] {
	const excludedSlugs = [
		'pec-zwolle',
		'achilles-29',
		'fortuna-sittard',
		'sparta-rotterdam',
		'fc-twente',
		'go-ahead-eagles',
		'n-e-c',
		'fc-groningen',
		'telstar',
		'excelsior',
		'ado-den-haag',
		'sc-cambuur',
		'willem-ii',
	];
	return teams?.filter((team) => team.slug && !excludedSlugs.includes(team.slug));
}

export default filterTeams;
